import React from 'react';
import ReactDOM from 'react-dom/client';

import InitializeSentry from 'initialize-sentry';

import reportWebVitals from './reportWebVitals';
import 'styles/index.css';

InitializeSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const importBuildTarget = (): Promise<any> => {
  if (process.env.REACT_APP_BUILD_TARGET === 'week-planner') {
    return import('app');
  }
  return import('app');
  /* return Promise.reject(
    new Error(`No such build target: ${process.env.REACT_APP_BUILD_TARGET}`),
  ); */
};

importBuildTarget().then(({ default: Environment }) =>
  root.render(
    <React.StrictMode>
      <Environment />
    </React.StrictMode>,
  ),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
